<template>
  <div>
    <b-table
      hover
      responsive
      :items="items"
      :fields="fields"
      head-variant="light"
      fixed
      bordered
      :busy.sync="isLoading"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" />
        </div>
      </template>
      <template #empty>
        <div class="text-center text-info my-2">Không có dữ liệu</div>
      </template>
      <template #emptyfiltered="{ emptyFilteredText }">
        <h4>{{ emptyFilteredText }}</h4>
      </template>
      <template #cell(index)="{ index }">
        {{ (page - 1) * limit + index + 1 }}
      </template>
      <template #cell(info)="{ item }">
        <template v-if="['MERCHANT_ACCOUNT'].includes(level)">
          <div class="text-primary">
            <span>{{ item.accountName }}</span>
            <span
              v-if="item._error"
              class="cursor-pointer"
              v-b-tooltip.hover="{ customClass: 'tooltip-class' }"
              v-b-tooltip="item._error"
            >
              <img class="ml-1 align-text-bottom" src="@/assets/img/warning.svg" alt="" />
            </span>
          </div>
          <div>
            <a :href="`mailto:${item.email}`">{{ maskSensitiveInfo(item.email) }}</a>
            <i
              v-if="item.sender?.email"
              @click="copyToClipboard(item?.email || '')"
              style="font-size: 16px; margin-left: 5px; color: gray; cursor: pointer"
              class="bx bxs-copy"
            ></i>
          </div>
          <div>
            <b-icon icon="geo-alt"></b-icon>
            <strong>{{ item.businessRegistrationAddress }}</strong>
          </div>
        </template>
        <template v-else-if="['STORE'].includes(level)">
          <div class="text-primary">
            <span>{{ item.storeName }}</span>
            <span
              v-if="item._error"
              class="cursor-pointer"
              v-b-tooltip.hover="{ customClass: 'tooltip-class' }"
              v-b-tooltip="item._error"
            >
              <img class="ml-1 align-text-bottom" src="@/assets/img/warning.svg" alt="" />
            </span>
          </div>
          <div>{{ getAdressByCode(item) }}</div>

          <div>
            <b-icon icon="geo-alt"></b-icon>
            <strong
              class="text-primary"
              style="cursor: pointer"
              @click="showMapModal(item.latitude, item.longitude, getAdressByCode(item))"
            >
              {{ item.address }}
            </strong>
          </div>
        </template>
      </template>
      <template #cell(staff)="{ item }">
        <div v-if="item.staffMain">
          <span class="text-muted">Chính</span>:
          <strong :class="getColorOldMain(item)">
            {{
              `${item.staffMain.name} - ${item.staffMain.types?.map(type => asignType[type]).join(', ')}`
            }}
          </strong>
        </div>
        <div v-if="item.staffSecond?.length">
          <span class="text-muted"> Phụ </span>:
          <span
            v-for="(staff, index) in item.staffSecond"
            :key="staff.id"
            :class="getColorOldStaff(item, staff.id)"
          >
            {{
              `${staff.name} - ${staff.types?.map(type => asignType[type]).join(', ')}${index < item.staffSecond.length - 1 ? '; ' : ''}`
            }}
          </span>
        </div>
      </template>
      <template #cell(staffNew)="{ item }">
        <div v-show="newMainStaffShow(item)">
          <span class="text-muted"> Chính </span>:
          <strong :class="getColorNewMain(item)">
            {{ newMainStaffShow(item) }}
          </strong>
        </div>
        <div v-if="staffSecondShow(item).length">
          <span class="text-muted"> Phụ </span>:
          <span
            v-for="(staff, index) in staffSecondShow(item)"
            :key="staff.id"
            :class="{ 'text-success': staff.isAdd }"
          >
            {{
              `${staff.name} - ${staff.types?.map(type => asignType[type]).join(', ')}${
                index < staffSecondShow(item).length - 1 ? '; ' : ''
              }`
            }}
          </span>
        </div>
      </template>
      <template #cell(actions)="{ item }">
        <div v-show="isShowRemove">
          <b-link @click.prevent="removeAccount(item.id)" size="sm" class="text-danger">Xóa</b-link>
        </div>
        <div>
          <b-link
            v-if="['MERCHANT_ACCOUNT'].includes(level)"
            :href="`/customer-support/account/${item.id}/history-assign`"
            size="sm"
            target="_blank"
          >
            Lịch sử gán CS
          </b-link>
          <b-link
            v-else-if="['STORE'].includes(level)"
            :href="`/customer-support/store/${item.id}/history-assign`"
            size="sm"
            target="_blank"
          >
            Lịch sử gán CS
          </b-link>
        </div>
      </template>
    </b-table>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longtitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal ref="map-address" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <iframe loading="lazy" :src="url" height="500" style="width: 100%" frameborder="0"></iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
  // import ExcelJS from 'exceljs';
  import { showMess } from '@/config/utils'

  export default {
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      level: {
        type: String,
        default: 'STORE',
      },
      items: {
        type: Array,
        default: function () {
          return []
        },
      },
      selectedEmployees: {
        type: Array,
        default: function () {
          return []
        },
      },
      asignType: {
        type: Object,
        default: function () {
          return {}
        },
      },
      isShowRemove: {
        type: Boolean,
        default: true,
      },
      limit: {
        type: Number,
        default: 20,
      },
      page: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        fields: [
          {
            key: 'index',
            label: 'STT',
            thStyle: 'width: 30px',
            tdClass: 'text-right',
          },
          { key: 'info', label: 'Thông tin chung', thStyle: 'min-width: 400px' },
          {
            key: 'staff',
            label: 'NV chăm sóc hiện tại',
            thStyle: 'min-width: 200px; max-width: 400px',
          },
          {
            key: 'staffNew',
            label: 'NV chăm sóc đã cập nhật',
            thStyle: 'min-width: 200px; max-width: 400px',
          },
          {
            key: 'actions',
            label: 'Hành động',
            thStyle: 'width: 150px',
            tdClass: 'text-center',
          },
        ],
        latitude: 0.0,
        longtitude: 0.0,
        url: null,
      }
    },
    computed: {
      newMainStaff() {
        return this.selectedEmployees.find(staff => staff.isMain)
      },

      newMainStaffShow() {
        return row => {
          if (this.newMainStaff) {
            return `${this.newMainStaff.name} - ${this.newMainStaff.types?.map(type => this.asignType[type]).join(', ')}`
          } else if (row.staffMain) {
            return `${row.staffMain.name} - ${row.staffMain.types?.map(type => this.asignType[type]).join(', ')}`
          }
          return ''
        }
      },

      staffSecondShow() {
        return row => {
          // list ids of old staff
          const ids =
            row.staffSecond?.reduce((arr, staff) => {
              arr.push(staff.id)
              return arr
            }, []) || []

          // add main staff to list
          // if (row.staffMain && (!this.newMainStaff || this.newMainStaff.id === row.staffMain.id)) {
          //   ids.push(row.staffMain.id)
          // }

          // old list second staff
          const list = row.staffSecond.length
            ? row.staffSecond
                .filter(staff => staff.id !== this.newMainStaff?.id)
                .map(staff => {
                  return {
                    ...staff,
                    isAdd: false,
                  }
                })
            : []

          // new main !== old main
          // if (row.staffMain && this.newMainStaff && this.newMainStaff?.id !== row.staffMain?.id) {
          //   !ids.includes(row.staffMain?.id) && (() => {
          //     list.push({
          //       ...row.staffMain,
          //       isAdd: true
          //     });
          //     ids.push(row.staffMain?.id);
          //   })()
          // }

          // add new staff in new selected
          const staffsAdd = this.selectedEmployees.filter(
            staff => !staff.isMain && !ids.includes(staff.id)
          )
          if (staffsAdd.length) {
            for (const staff of staffsAdd) {
              list.push({
                ...staff,
                isAdd: true,
              })
            }
          }
          return list
        }
      },
      getColorOldMain() {
        return row => {
          return row.staffMain && this.newMainStaff && row.staffMain?.id !== this.newMainStaff.id
            ? 'text-danger'
            : ''
        }
      },
      getColorNewMain() {
        return row => {
          return this.newMainStaff && this.newMainStaff.id !== (row.staffMain?.id || 0)
            ? 'text-success'
            : ''
        }
      },
      getColorOldStaff() {
        return (row, userId) => {
          return ''
        }
      },
    },
    methods: {
      copyToClipboard(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            showMess(
              this,
              'Success',
              'Sao chép thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
          .catch(err => {
            console.error('Lỗi khi sao chép: ', err)
            showMess(
              this,
              'Error',
              'Lỗi khi sao chép: ' + err,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
      },
      maskSensitiveInfo(input) {
        if (input.includes('@')) {
          return input.replace(/(.{2}).+(@.+)/, '$1****$2')
        } else if (/^(\d{10})$/.test(input) || /(\d{2,3})\d{4}(\d{3,4})/.test(input)) {
          return input.replace(/(\d{2,3})\d{4}(\d{3,4})/, '$1****$2')
        } else {
          return input.replace(/(.{3}).+(.{3})/, '$1****$2')
        }
      },
      removeAccount(id) {
        this.$emit('remove', id)
      },
      showMapModal(lat, long, address) {
        if (lat && long) {
          this.latitude = Number.isInteger(this.latitude) ? lat : parseFloat(lat)
          this.longtitude = Number.isInteger(this.longtitude) ? long : parseFloat(long)
          this.$refs['modal-map'].show()
        } else {
          this.url = `https://maps.google.com/maps?q=${address}&output=embed`
          this.$refs['map-address'].show()
        }
      },
      getAdressByCode(item) {
        const addressArr = []
        if (item.districtName) {
          addressArr.push(item.districtName)
        }
        if (item.provinceName) {
          addressArr.push(item.provinceName)
        }
        if (item.regionName) {
          addressArr.push(item.regionName)
        }
        return addressArr.length > 0 ? addressArr.join(', ') : item.address
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list-help {
    border: 1px solid #dcdcdc;
    border-radius: 12px;
    padding: 12px;
    margin-right: 10px;

    h3 {
      font-size: 14px;
      text-transform: uppercase;
      margin-bottom: 15px !important;
      font-weight: normal !important;
    }
    label {
      font-weight: 600;
    }

    ul {
      margin-left: 15px;
      margin-bottom: 17px;
      li {
        font-size: 12px;
        list-style: disc;
        label {
          font-weight: 600;
        }
      }
    }
  }
</style>
